import { render, staticRenderFns } from "./ApplicantCollectionPage.vue?vue&type=template&id=553912ce&"
import script from "./ApplicantCollectionPage.vue?vue&type=script&lang=ts&"
export * from "./ApplicantCollectionPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('553912ce')) {
      api.createRecord('553912ce', component.options)
    } else {
      api.reload('553912ce', component.options)
    }
    module.hot.accept("./ApplicantCollectionPage.vue?vue&type=template&id=553912ce&", function () {
      api.rerender('553912ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Applicant/ApplicantCollectionPage.vue"
export default component.exports